import { breakpointTo, bpMedium } from 'tokens';
import { useMedia } from 'react-use';
import { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import PaymentLinkContext from '@/pages/Checkout/context/PaymentLinkContext';

import { IObjectSteps } from '@/pages/Checkout/types/paymentLinkContextTypes';

import Details from '@/pages/Checkout/components/Details';
import PersonalInformation from '@/pages/Checkout/components/PersonalInformation';
import Address from '@/pages/Checkout/components/Address';
import Card from '@/pages/Checkout/components/CreditCard';
import PaymentMethod from '@/pages/Checkout/components/PaymentMethod';

const useCheckout = () => {
  const isMobile = useMedia(breakpointTo(bpMedium));
  const navigate = useNavigate();

  const {
    getLinkIsLoading,
    currentStep,
    errorRedirect,
    postIsLoading,
    loadingPage,
  } = useContext(PaymentLinkContext);

  const getStepsByDevice = () => {
    const allSteps: IObjectSteps = {
      details: Details,
      paymentMethod: PaymentMethod,
      personal: PersonalInformation,
      address: Address,
      credit: Card,
    };

    if (!isMobile) {
      delete allSteps.details;
      return allSteps;
    }

    return allSteps;
  };

  const CurrentStep = useMemo(() => {
    const steps = getStepsByDevice();

    const key = currentStep as keyof typeof steps;

    return steps[key] || PersonalInformation;
  }, [currentStep]);

  return {
    getLinkIsLoading,
    errorRedirect,
    postIsLoading,
    CurrentStep,
    navigate,
    loadingPage,
  };
};

export default useCheckout;
